import { DIMENSIONS } from "utils/Dimensions";

export function getColumnsArray(fullColumns, isAddColumnShown = true, isMainView = 0, isSubsheet = false, userEventsWidth, viewConfig) {
  var columnDefs = [],
    columnsWithAggregation = {};

  fullColumns.map((column, index) => {
    if(column.name == 'CurrentJSONData'){
      if(window.appStore?.containerStore?.listConfig?.list?.is_log_sheet){
        return null
      }
    }
    columnDefs.push(getColumnDef(column, isMainView, viewConfig));
    if (
      ((column["column_type_id"] === "5" ||
        column["column_type_id"] === "22" ||
        column["column_type_id"] === "17") &&
        column["alias_name"] !== "createdBy") ||
      ((column["column_type_id"] == "19" || column["column_type_id"] == "7") &&
        (column["options"]?.["formula_column"]?.["column_type_id"] == 17 ||
          column["options"]?.["formula_column"]?.["column_type_id"] == 5))
    ) {
      columnsWithAggregation[[column["dataIndex"]]] = "Sum";
    }
    return 0;
  });
  let IdColumn = columnDefs.shift();
  let starColumn = columnDefs.filter(col => col?.cellEditorParams?.columnOptions?.is_star_column == true);
  let filteredColumnDefs = columnDefs.filter(col => !col?.cellEditorParams?.columnOptions?.is_star_column);

  let isSubsheetView =
    viewConfig?.type == "table" &&
    viewConfig?.list_id &&
    viewConfig?.options?.main_list_id &&
    viewConfig?.list_id != viewConfig?.options?.main_list_id;
  
  if (!isSubsheetView) {
  // if (!hideUserEventsColumn || isSubsheet) {
    filteredColumnDefs.unshift({
      colId: "userEvents",
      ...(userEventsWidth && { width: userEventsWidth }),
      headerName: "",
      field: "column_userEvents",
      pinned: "left",
      suppressMovable: true,
      headerClass: null,
      lockPosition: true,
      floatingFilter: false,
      cellRendererParams: {
        columnTypeId: "",
        columnOptions: "[{}]",
        enableMenu: false,
        enableSorting: false,
      },
      cellClass: ["display-not-flex"],
      cellClassRules: {
        "border-top-add-row": function (params) {
          return params.data?.row_id === "+" && params.value != "+";
        },
        "no-border": function (params) {
          return params.value === "+r0w" || (params.value === "+" && params.colDef.colId !== "Id");
        },
      },
      cellRendererSelector: function (params) {
        var renderer = {
          component: "multiLineRenderer",
        };
        if (
          params?.colDef?.colId === "userEvents" &&
          params?.node?.data?.row_id !== "+" &&
          !params?.node?.group &&
          params?.node?.data?.hasOwnProperty("row_id") &&
          params?.node?.data?.row_id !== ""
        ) {
          renderer.component = "userEventsRenderer";
        }
        return renderer;
      },
      cellEditorParams: {
        eventHandlers: {},
      },
      editable: false,
      resizable: true,
      hide: false,
    });
  // }
  }
  
  filteredColumnDefs.unshift(IdColumn);
  
  // Find the index of IdColumn and add starColumn after it
  let idColumnIndex = filteredColumnDefs.findIndex(col => col.colId === IdColumn.colId);

  if (idColumnIndex !== -1 && starColumn) {
    filteredColumnDefs.splice(idColumnIndex + 1, 0, ...starColumn);
  }

  if (isAddColumnShown) {
    filteredColumnDefs.push({
      colId: "+",
      headerName: "+",
      field: "column_+",
      headerComponent: "addColumnHeader",
      suppressMovable: true,
      floatingFilter: false,
      cellRendererParams: {
        columnTypeId: "",
        columnOptions: "[{}]",
        enableMenu: false,
        enableSorting: false,
      },
      cellEditorParams: {
        eventHandlers: {},
      },
      editable: false,
      // cellClass: "addColumnCells",
      cellClassRules: {
        addColumnCells: function (params) {
          return true;
        },
      },
      resizable: false,
      width: 100,
      hide: false,
    });
  }
  return {
    columnDefs: filteredColumnDefs,
    columnsWithAggregation: columnsWithAggregation,
  };
}

export function getDataArray(fullColumns, fullData) {
  var rowData = [],
    pinnedBottomRowData = [],
    individualDataObject = { children: [] };
  fullData.map((data) => {
    fullColumns.map((column) => {
      // var subsheetDataObject = {};
      individualDataObject[column.dataIndex] = data[column.dataIndex];
      // if (column.column_type_id === "6") {
      //   subsheetData.map((row) => {
      //     column.list_columns.map((column) => {
      //       subsheetDataObject["column_" + column.id] =
      //         row["column_" + column.id];
      //       return 0;
      //     });
      //     individualDataObject.children.push(subsheetDataObject);
      //     subsheetDataObject = {};
      //     return 0;
      //   });
      // }
      return 0;
    });
    individualDataObject.uniqueId = individualDataObject.row_id;
    rowData.push(individualDataObject);
    individualDataObject = { children: [] };
    return 0;
  });
  fullColumns.map((column) => {
    individualDataObject[column.dataIndex] = column["header"];
    return 0;
  });
  rowData = rowData.reverse();
  // rowData.push({
  //   row_id: "+",
  // });
  // rowData.unshift({
  //   row_id: "+",
  // });
  pinnedBottomRowData.push(individualDataObject);
  return { rowData: rowData, pinnedBottomRowData: pinnedBottomRowData };
}

export function setEditorRenderer(column) {
  if (
    column["alias_name"] === "createdBy" ||
    column["header"] === "Created By" ||
    column["name"] === "Created By"
  ) {
    return {
      cellEditor: "textEditor",
      cellRenderer: "multiLineRenderer",
    };
  }
  if (column["column_type_id"] === "1" && column["options"]["is_star_column"] == true ) {
    return {
      cellEditor: "starEditor",
      cellRenderer: "starRenderer",
    };
  }

  switch (column["column_type_id"]) {
    case "id":
      return {
        cellEditor: "",
        cellRenderer: "rowIdRenderer",
      };
    case "comments_id":
      return {
        cellEditor: "commentsIdEditor",
        cellRenderer: "commentsIdRenderer",
      };
    case "14":
      return {
        cellEditor: "textEditor",
        cellRenderer: "emailRenderer",
      };
    case "1":
    case "24":
    case "18":
    case "20":
      return {
        cellEditor: "textEditor",
        cellRenderer: "multiLineRenderer",
      };
    case "3":
      return {
        cellEditor: "dropdownEditor",
        cellRenderer: "dropdownRenderer",
      };
    case "4":
    case "16":
      return {
        cellEditor: "dateEditor",
        cellRenderer: "dateRenderer",
      };
    case "6":
      return {
        cellEditor: "subsheetEditor",
        cellRenderer: "subsheetRenderer",
      };
    case "7":
    case "19":
      return {
        cellEditor: "formulaEditor",
        cellRenderer: getFormulaRenderer(
          column["options"]?.["formula_column"]?.["column_type_id"]
        ),
      };
    case "11":
      return {
        cellEditor: "multiselectEditor",
        cellRenderer: "multiselectRenderer",
      };
    case "12":
      return {
        cellEditor: "booleanEditor",
        cellRenderer: "booleanRenderer",
      };
    case "13":
      return {
        cellEditor: "checkboxGroupEditor",
        cellRenderer: "checkboxGroupRenderer",
      };
    case "8":
      return {
        cellEditor: "multiLineEditor",
        cellRenderer: "multiLineRenderer",
      };
    case "9":
      return {
        cellEditor: "fileEditor",
        cellRenderer: "fileRenderer",
      };
    case "10":
      return {
        cellEditor: "lookupEditor",
        cellRenderer: "lookupRenderer",
      };
    case "5":
    case "22":
    case "17":
      return {
        cellEditor: "numberEditor",
        cellRenderer: "numberRenderer",
      };
    case "15":
      return {
        cellEditor: "textEditor",
        cellRenderer: "passwordRenderer",
      };
    default:
      return {
        cellEditor: "",
        cellRenderer: "multiLineRenderer",
      };
  }
}

function getFormulaRenderer(columnTypeId) {
  switch (parseInt(columnTypeId)) {
    case 4:
    case 16:
      return "dateRenderer";
    case 5:
    case 17:
      return "numberRenderer";
    default:
      return "multiLineRenderer";
  }
}

export function getColumnDef(column, isMainView = 0, viewConfig) {
  var { cellEditor, cellRenderer } = setEditorRenderer(column);
  if (column.options?.is_read_only || !column.hasOwnProperty("column_type_id")) {
    cellEditor = "formulaEditor";
  }
  if (column.options?.is_read_only && column?.column_type_id == 9) {
    cellEditor = "fileEditor";
  }
  if (!column["header"]) {
    column["header"] = column["name"];
  }
  return {
    colId: column["alias_path"],
    aliasPath: column["alias_path"],
    dataIndex: column["dataIndex"],
    headerName:
      isMainView == "1"
        ? (column["name"] ?? column["header"])
        : (column["header"] ?? column["name"]) +
          (column.options?.is_mandatory ? " *" : ""),
    field: column["dataIndex"],
    width: (column["header"] === "Star" || column["name"] === "Star") 
    ? (typeof column["col_width"] === "undefined" ? 90 :  Number(column["col_width"]))
    : Number(column["col_width"]) + (column["header"] === "Id" && Number(column["col_width"]) === 100 ? 20 : 0),
    valueGetter: (params) => {
      const value = params.data?.[column.dataIndex];

      if (value && column.column_type_id == 4) {
        const dateSplit = value.split(" ");
        return dateSplit[0];
      }
      return value;
    },
    // rowDrag: function (params) {
    //   return column["header"] === "Id" && params.node.data.row_id !== "+";
    // },
    pinned: column["header"] === "Id" || column["header"] === "Actions" || column["header"] === "Parent Row Id"
    ? "left"
    : (column["header"] === "Star" || column["name"] === "Star")
    ? (typeof column["pinned"] !== "undefined" ? column["pinned"] : "left")
    : column["pinned"] ?? null,
    suppressMovable:
      column["header"] === "Id" ||
      column["header"] === "Star" || column["name"] === "Star" ||
      column["header"] === "Actions" ||
      column["header"] === "" ||
      column["header"] === "Parent Row Id"
        ? true
        : false,
    headerClass: column["header"] === "$Events" ? "header-style" : null,
    lockPosition:
      column["header"] === "Id" ||
      column["header"] === "Star" || column["name"] === "Star" ||
      column["header"] === "Actions" ||
      column["header"] === "" ||
      column["header"] === "Parent Row Id"
        ? true
        : false,
    filter: getFilter(column),
    filterParams: {
      valueFormatter: blankCellFilterFormatter, // formats filter values
      comparator: function (a, b) {
        const nameA = a?.toUpperCase();
        const nameB = b?.toUpperCase();
        let comparison = 0;
        if (a === "+r0w" || b === "+r0w") {
          comparison = 1;
        } else if (nameA > nameB) {
          comparison = 1;
        } else if (nameA < nameB) {
          comparison = -1;
        }
        return comparison;
      },
    },
    editable: function (params) {
      if(params?.colDef?.aliasPath =='$Events' || params?.colDef?.headerName =='$Events'){
        return false;
      }
      if (params?.colDef?.cellRendererParams?.columnTypeId === 'comments_id' && !params?.data?.row_id) {
        return false;
      }
      if (params?.colDef?.cellRendererParams?.columnTypeId == 1 && params?.colDef?.cellRendererParams?.columnOptions.is_star_column == true && !params?.data?.row_id) {
        return false;
      }
      if (params?.colDef?.store.isSubsheet) {
        if (params.colDef?.store.parentListId) {
          const parentListContainerStore = window.appStore.getCurrentListContainerStore(params.colDef.store.parentListId);
          const hasEditPermissions = parentListContainerStore?.permissions?.canEdit(params.colDef.store.parentColumnId, params.colDef.store.parentRow);
          if (hasEditPermissions && !hasEditPermissions[0] && params?.colDef?.cellRendererParams?.columnTypeId != '9') {
            return false;
          }
        }
        return canEditable(params, column);
      }

      if (
        viewConfig?.type == "table" &&
        viewConfig?.list_id &&
        viewConfig?.options?.main_list_id &&
        viewConfig?.list_id != viewConfig?.options?.main_list_id
      ) {
        return false;
      }
      
      if (
        ((Number(params.node.data.row_id) &&
          params?.colDef?.store?.containerStore?.permissions.canEdit(
            params?.colDef?.cellRendererParams?.columnId,
            params?.node?.data
          )[0]) ||
          (!Number(params.node.data.row_id) &&
            params?.colDef?.store?.containerStore?.permissions.canAdd() &&
            params?.colDef?.store?.containerStore?.permissions.canAddColumn(
              params?.colDef?.cellRendererParams?.columnId
            )[0])) &&
        canEditable(params, column)
      ) {
        return true;
      } else {
        if(!(params.node.isRowPinned() && params.node?.rowPinned && params.node?.rowPinned === "bottom" && params.node.data.row_id == "") && (params?.colDef?.cellRendererParams?.columnTypeId == '9' || params?.colDef?.cellRendererParams?.columnTypeId == '6' || params?.colDef?.cellRendererParams?.columnTypeId == 'comments_id' ||  params?.colDef?.cellRendererParams?.columnTypeId == '8')) {
          return true;
        }
        return false;
      }
    },
    singleClickEdit:
      column["column_type_id"] === "9" || column["column_type_id"] === "6",
    menuTabs: ["generalMenuTab", "filterMenuTab"],
    cellStyle: function (params) {
      if (column["header"] === "$Events") {
        return {
          border: "none !important",
        };
      } else if (params.value !== "+" || params.value) {
        let cellBackgroundColor =
          params.data &&
          params.data[
            "column_" + params.colDef.cellRendererParams.columnId + "_bg_color"
          ]
            ? params.data[
                "column_" +
                  params.colDef.cellRendererParams.columnId +
                  "_bg_color"
              ] + " !important"
            : "none";
        if (params.node.rowHeight >= DIMENSIONS.cell_height_medium) {
          return {
            "line-height": "1.5em",
            "word-break": "break-all",
            "white-space": "normal",
            "text-overflow": "ellipsis",
            overflow: "hidden",
            "background-color": cellBackgroundColor,
          };
        } else {
          return {
            "word-break": "break-all",
            "text-overflow": "ellipsis",
            "background-color": cellBackgroundColor,
          };
        }
      }
    },
    cellClassRules: {
      "border-top": function (params) {
        return params.colDef.colId === "";
      },
      // "no-border": function (params) {
      //   return params.value === "+r0w";
      // },
      "border-top-add-row": function (params) {
        return params.data?.row_id === "+" && params.value != "+";
      },
      "no-border": function (params) {
        return (
          params.value === "+r0w" ||
          (params.value === "+" && params.colDef.colId !== "Id")
        );
      },
      "text-area-cell-bottoms": function (params) {
        if (
          column["column_type_id"] === "8" &&
          (params.node?.rowIndex ===
            params.api?.rowModel?.rowsToDisplay?.length - 2 ||
            params.node?.rowIndex ===
              params.api?.rowModel?.rowsToDisplay?.length - 3)
        ) {
          return true;
        }
      },
      "border-right": function (params) {
        return params.colDef.colId === "Id" && params.value !== "+";
      },
      "no-border-right": function (params) {
        return params.colDef.colId === "Id" && params.value === "+";
      },
    },
    cellEditorSelector: function (params) {
      if (
        params.node.isRowPinned() &&
        (column["column_type_id"] === "5" ||
          column["column_type_id"] === "17" ||
          column["column_type_id"] === "22" ||
          ((column["column_type_id"] == "19" ||
            column["column_type_id"] == "7") &&
            (column["options"]?.["formula_column"]?.["column_type_id"] == 17 ||
              column["options"]?.["formula_column"]?.["column_type_id"] == 5)))
      )
        return {
          component: "customPinnedRowEditor",
        };
      else return { component: cellEditor };
    },
    cellEditorParams: {
      eventHandlers: JSON.parse(column["event_handlers"] || "{}"),
      columnOptions: column["options"],
    },
    cellRendererSelector: function (params) {
      var renderer = {
        component: cellRenderer,
      };
      if (
        params?.node?.group &&
        !params?.value &&
        params?.colDef?.colId !== "Id" &&
        params?.colDef?.colId !== "Actions"
      ) {
        renderer.component = "groupedCellRenderer";
      }
      if (
        params?.colDef?.colId === "Actions" &&
        !params?.node?.group &&
        params?.node?.data?.row_id !== "+"
      ) {
        renderer.component = "triggerRenderer";
      }
      if (
        params?.colDef?.colId === "$Events" &&
        !params?.node?.group &&
        params?.node?.data?.row_id !== "+"
      ) {
        renderer.component = "eventRenderer";
      }
      return renderer;
    },
    cellRendererParams: {
      columnTypeId: column["column_type_id"],
      columnOptions: column["options"],
      columnId: column["id"],
      enableMenu:
        column["header"] === "Actions" ||
        column["header"] === "$Events" ||
        column["header"] === ""
          ? false
          : true,
      enableSorting: true,
      listColumns: column.list_columns,
      columnRaw: column,
    },
    floatingFilterComponent: "searchFloatingFilter",
    pinnedRowCellRenderer: "customPinnedRowRenderer",
    rowGroup: false,
    hide: false,
    rowGroupIndex: null,
    rowGroupOption: column["column_type_id"] == "4" || column["column_type_id"] == "16" ? "my" : null,
    comparator: getSortComparator(column["column_type_id"]),
  };
}

function getSortComparator(column_type_id) {
  switch (column_type_id) {
    case "5":
    case "22":
    case "17":
      return function (number1, number2) {
        return number1 - number2;
      };
    case "4":
    case "16":
      return function createDateComparator(date1, date2) {
        return new Date(date1) - new Date(date2);
      };
    case "id":
    case "parentRowId":
      return function (number1, number2) {
        return parseInt(number1) - parseInt(number2);
      };
    default:
      return "";
  }
}

function getFilter(column) {
  if (!column) {
    return "textFilter";
  }

  if (column["header"] == "Parent Row Id"  || column["header"] === "Notes/Comments") {
    return false;
  }

  if(column["header"]?.toLowerCase() === "id") {
    return "textFilter";
  }

  switch (column["column_type_id"]) {
    // case "1":
    // case "14":
    // case "18":
    //   return "agTextColumnFilter";
    case "4":
    case "16":
    case 16:
      return "dateFilter";
    case "5":
    case "22":
    case "17":
    case 17:
      if (column["alias_name"] === "createdBy" ||
      column["header"] === "Created By" ||
      column["name"] === "Created By") {
      return "textFilter";
    }
      return "agNumberColumnFilter";
    case "9":
      return false;
    case "7":
    case "19":
      return getFilter(column["options"]?.["formula_column"]);
    default:
      return "textFilter";
  }
}

function blankCellFilterFormatter(params) {
  if (params.value === "+r0w") return "New Entry Row";
  return params.value;
}

function canEditable(params, column) {
  return (
    (!params.node.isRowPinned() ||
      column["column_type_id"] === "5" ||
      column["column_type_id"] === "22" ||
      column["column_type_id"] === "17" ||
      ((column["column_type_id"] == "19" || column["column_type_id"] == "7") &&
        (column["options"]?.["formula_column"]?.["column_type_id"] == 17 ||
          column["options"]?.["formula_column"]?.["column_type_id"] == 5))) &&
    params.node.data.row_id !== "+" &&
    column["header"] !== "Id" &&
    column["header"] !== "Actions" &&
    column["header"] !== "" &&
    column["header"] !== "Created By" &&
    column["column_type_id"] !== 16
  );
}
